import CloseIcon from "@mui/icons-material/Close";

export function EmailModalItem({ email, onRemove }: { email: string; onRemove: () => void }) {
  return (
    <li
      className="flex items-center justify-between font-lato"
      style={{
        padding: "8px 12px",
        border: "1px solid var(--color-card-border)",
        borderRadius: "var(--radius-sm)",
        marginBottom: 6,
        fontSize: 14,
        color: "var(--color-rodeo-black)",
      }}
    >
      <span>{email}</span>
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${email}`}
        className="bg-transparent border-none cursor-pointer p-0.5 leading-none text-graphite hover:text-good-wine transition-colors"
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </button>
    </li>
  );
}
